module.exports = __webpack_public_path__ + "static/images/styles/images/reserves/rewards/battle-payments-elite-reward-50.f20b511a.png";


//////////////////
// WEBPACK FOOTER
// ./styles/images/reserves/rewards/battle-payments-elite-reward-50.png
// module id = 3779
// module chunks = 11